<template>
  <div class="form-group">
    <b-form-input
      :value="value"
      :state="run.mensaje.length > 0 ? (run.modificado ? null : false) : null"
      type="text"
      placeholder="Número de Documento"
      class="form-control"
      id="recipient-rut"
      maxlength="12"
      @input="handler"
      @blur="validacionRun"
    />
    <b-form-invalid-feedback v-if="run.mensaje.length > 0">{{ run.mensaje }}</b-form-invalid-feedback>
    <div>
      <span>Tipo de Documento:</span>
      <b-form-radio-group
        id="radio-group-1"
        v-model="tipoDocumento"
        :options="options"
        name="radio-options"
        size="sm"
      ></b-form-radio-group>
    </div>
  </div>
</template>

<script>
import { validacion } from "@/utils/ValidacionGenerica";
export default {
  name: "InputRutWrapper",
  props: ["value"],
  data() {
    return {
      run: {
        valor: "",
        mensaje: "",
        modificado: null,
      },
      tipoDocumento: "RUT",
      options: [
        { text: "RUT", value: "RUT" },
        { text: "Pasaporte", value: "PASAPORTE" },
      ],
    };
  },
  watch: {
    tipoDocumento() {
      this.$emit("input", "");
      this.run.valor = "";
      this.run.mensaje = "";
      this.run.modificado = null;
    },
  },
  methods: {
    handler(e) {
      let runFormateado = this.tipoDocumento === "RUT" ? this.formato(e) : e;
      this.$emit("input", runFormateado);
    },
    formato(valor) {
      let actual = valor.replace(/^0+/, "");
      let runPuntos = "";
      if (actual != "" && actual.length > 1) {
        let sinPuntos = actual.replace(/\./g, "");
        let actualLimpio = sinPuntos.replace(/-/g, "");
        let inicio = actualLimpio.substring(0, actualLimpio.length - 1);
        let j = 1;
        for (let i = inicio.length - 1; i >= 0; i--) {
          let letra = inicio.charAt(i);
          runPuntos = letra + runPuntos;
          if (j % 3 == 0 && j <= inicio.length - 1) {
            runPuntos = "." + runPuntos;
          }
          j++;
        }
        let dv = actualLimpio.substring(actualLimpio.length - 1);
        runPuntos = runPuntos + "-" + dv;
      } else {
        runPuntos = valor;
      }
      return runPuntos;
    },
    validacionRun() {
      let json = this.run;
      json.valor = this.value;
      if (this.tipoDocumento === "RUT") {
        if (json.valor.trim() === "") {
          json.modificado = false;
          json.mensaje = "Campo obligatorio";
        } else if (
          !/^(\d{1,3}\.\d{3}\.\d{3}-(\d|K|k))|(\d{7,8}-?(\d|k|K))$/.test(
            json.valor
          ) ||
          !this.digitoVerificador(json.valor)
        ) {
          json.modificado = false;
          json.mensaje = "Valor ingresado no es válido";
        } else {
          json.modificado = true;
          json.mensaje = "";
        }
      } else {
        if (json.valor.trim() === "") {
          json.modificado = false;
          json.mensaje = "Campo obligatorio";
        } else if (validacion("ALFANUMERICO", json.valor)) {
          json.modificado = false;
          json.mensaje = "Valor ingresado no es válido";
        } else {
          json.modificado = true;
          json.mensaje = "";
        }
      }

      this.run = Object.assign({}, json);
      return json.modificado;
    },
    digitoVerificador(run) {
      if (run) {
        let runSeparado = this.separarRun(run);
        let verificador = runSeparado.digitoVerificador;
        let cadena = runSeparado.run;
        let valor = 0;
        let serie = [2, 3, 4, 5, 6, 7];

        for (var i = 0; i < cadena.length; i++) {
          valor =
            valor +
            Number(cadena.charAt(cadena.length - (i + 1))) * serie[i % 6];
        }

        valor = 11 - (valor % 11);

        if (valor === 10) {
          return /^(k|K)$/.test(verificador);
        } else if (valor === 11) {
          return verificador === "0";
        } else {
          return Number(verificador) === valor;
        }
      }
      return false;
    },
    separarRun(string) {
      let dv = string.substr(string.length - 1);
      dv = dv === "k" || dv === "K" ? "K" : dv;
      return {
        digitoVerificador: dv,
        run: string.slice(0, -1).split(".").join("").replace("-", ""),
      };
    },
    getTipoDocumento() {
      return this.tipoDocumento;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/modales/InputRutWrapper.vue